import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { PublicOfferInterestFormService } from '../services/public-offer-interest-form.service';
import {
  PublicOfferInterestFormActions,
  PublicOfferInterestFormResetActions,
} from '../actions/public-offer-interest-form.actions';
import {
  PublicOfferInterestFormDetails,
  SendPublicOfferInterestFormResponse,
} from '@features/public-offer-interest-form/utils/models/public-offer-interest-form.model';

@Injectable()
export class PublicOfferInterestFormEffects {
  private readonly publicOfferInterestFormService = inject(PublicOfferInterestFormService);
  private readonly actions$ = inject(Actions);

  validateOfferInterestForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        PublicOfferInterestFormActions.validateOfferInterestForm,
        PublicOfferInterestFormResetActions.cancelPublicOfferInterestFormActions
      ),
      switchMap((action) =>
        action.type === PublicOfferInterestFormResetActions.cancelPublicOfferInterestFormActions.type
          ? of(PublicOfferInterestFormResetActions.cancelPublicOfferInterestFormActionsSuccess())
          : this.publicOfferInterestFormService.validateOfferInterestForm(action.offerHash).pipe(
              map((response: HttpResponse<PublicOfferInterestFormDetails>) =>
                PublicOfferInterestFormActions.validateOfferInterestFormSuccess({ data: response.message })
              ),
              catchError((error: HttpError) =>
                of(PublicOfferInterestFormActions.validateOfferInterestFormFailure({ error }))
              )
            )
      )
    );
  });

  sendOfferInterestForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicOfferInterestFormActions.sendOfferInterestForm),
      exhaustMap((action) =>
        this.publicOfferInterestFormService.sendOfferInterestForm(action.payload).pipe(
          map((response: HttpResponse<SendPublicOfferInterestFormResponse>) =>
            PublicOfferInterestFormActions.sendOfferInterestFormSuccess({ data: response.message })
          ),
          catchError((error: HttpError) => of(PublicOfferInterestFormActions.sendOfferInterestFormFailure({ error })))
        )
      )
    );
  });
}
